import * as React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

import { ANIMATIONS } from '../../utils';
import { CellFooter } from '../code-illustrations/CellFooter';
import { CellHeader } from '../code-illustrations/CellHeader';

const Wrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: absolute;
  z-index: 2;
`;

const Inner = styled.div`
  display: flex;
  align-items: flex-start;
  background: white;
  box-shadow: -1px 0px 0px rgba(2, 2, 27, 0.07),
    1px 0px 0px rgba(2, 2, 27, 0.07), 0px -1px 0px rgba(2, 2, 27, 0.07),
    0px 1px 0px rgba(2, 2, 27, 0.07), 0px 54px 74px rgba(1, 1, 27, 0.3),
    0px 14px 74px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  overflow: hidden;

  img {
    flex: none;
  }
`;

interface ProductIllustrationProps {
  cellLabel: string;
  className?: string;
  commentPopupOverride?: boolean;
  hideHeader?: boolean;
  hideHeaderActions?: boolean;
  imgPath: string;
  outputColor?: string;
  outputName?: string;
  showCommentCount?: boolean;
}

export const ProductIllustration: React.ComponentType<ProductIllustrationProps> =
  React.memo(
    ({
      cellLabel,
      commentPopupOverride = false,
      className,
      imgPath,
      outputName,
      outputColor,
      showCommentCount = false,
      hideHeader = false,
      hideHeaderActions = false
    }) => {
      return (
        <Wrapper {...ANIMATIONS.Cell} className={className}>
          {!hideHeader && (
            <CellHeader
              commentPopupOverride={commentPopupOverride}
              disabled={true}
              hideHeaderActions={hideHeaderActions}
              label={cellLabel}
              showCommentCount={showCommentCount}
            />
          )}
          <Inner>
            <img
              alt={cellLabel}
              src={`/images/${imgPath}.png`}
              srcSet={`/images/${imgPath}.png 1x, /images/${imgPath}@2x.png 2x`}
            />
          </Inner>
          {outputName && (
            <CellFooter outputColor={outputColor} outputName={outputName} />
          )}
        </Wrapper>
      );
    }
  );
